import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BankAccountResponse {
  rewardsUpdateDate: string;
  currentCashBackPercentChannel: string;
  rewardsExpirationDate: string;
  ban: string;
  linkageChannel: string;
  rewardsCreationAmount: string;
  lastBankStatusChange: string;
  linkageCount: string;
  accountCreationDate: string;
  previousCashBackPercentChannel: string;
  agentVerification: string;
  linkageDate: string;
  previousBankAccountStatus: string;
  currentCashBackPercent: string;
  balanceUnit: string;
  linkageMethod: string;
  accountUpdateDate: string;
  agentVerificationStatus: string;
  previousCashBackPercent: string;
  rewardsUpdateChannel: string;
  bankAccountStatus: string;
  previousLinkageBan: string;
  bankAccountId: string;
  rciFlag: string;
  rewardsUpdateReason: string;
  linkageStatus: string;
}

interface Contact {
  address: {
    country: {
      code: string;
      description: string;
    };
    city: string;
    postalCode: string;
    line1: string;
    line2: string;
  };
  correspondenceLanguage: {
    code: string;
    description: string;
  };
}

interface PointsDetails {
  availablePoints: number;
  onHoldPoints: number;
}

interface PointsDetailsResponse {
  statusCode: number;
  pointsDetailsResponse: {
    pointsDetails: PointsDetails;
    rewardBalance: number;
    redemptionBonusAmount: number;
  };
}

interface LoyaltyHubData {
  bankAccountResponse: BankAccountResponse;
  contact: Contact;
  pointDetails: PointsDetailsResponse;
  isUserEligible: boolean;
}

export interface lhState {
  loading: boolean;
  error: string | null;
  loyaltyHubData: LoyaltyHubData | null;
  isUserEligible: boolean;
  ssoRewardLhData: null;
  ssoLoading: boolean;
  ssoError: string | null;
  ssoLoginLoading: boolean;
  ssoLoginData: null;
  ssoLoginError: string | null;
}

const initialState: lhState = {
  loading: false,
  error: null,
  loyaltyHubData: null,
  isUserEligible: false,
  ssoRewardLhData: null,
  ssoLoading: false,
  ssoError: null,
  ssoLoginLoading: false,
  ssoLoginData: null,
  ssoLoginError: null,
};

const loyaltyHubSlice = createSlice({
  name: 'loyaltyHub',
  initialState,
  reducers: {
    fetchLoyaltyHubRequest(state, action) {
      state.loading = true;
      state.error = null;
    },
    fetchLoyaltyHubSuccess(state, action: PayloadAction<LoyaltyHubData>) {
      state.loading = false;
      state.loyaltyHubData = action.payload;
      state.isUserEligible = action.payload.isUserEligible;
      state.error = null;
    },
    fetchLoyaltyHubFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    fetchRewardRlhRequest(state, action) {
      state.ssoLoading = true;
      state.ssoError = null;
    },
    fetchRewardRlhSuccess(state, action) {
      state.ssoLoading = false;
      state.ssoRewardLhData = action.payload;
      state.ssoError = null;
    },
    fetchRewardRlhFailure(state, action: PayloadAction<string>) {
      state.ssoLoading = false;
      state.ssoError = action.payload;
    },
    lhSsoLoginRequest(state, action) {
      state.ssoLoginLoading = true;
      state.ssoLoginError = null;
    },

    lhSsoLoginSuccess(state, action) {
      state.ssoLoginLoading = false;
      state.ssoLoginData = action.payload;
      state.ssoLoginError = null;
    },

    lhSsoLoginFailure(state, action) {
      state.ssoLoginLoading = false;
      state.ssoLoginError = action.payload;
    },

    resetLoyaltyHubSlice() {
      return initialState;
    },
  },
});

export const {
  fetchLoyaltyHubRequest,
  fetchLoyaltyHubSuccess,
  fetchLoyaltyHubFailure,
  fetchRewardRlhRequest,
  fetchRewardRlhSuccess,
  fetchRewardRlhFailure,
  lhSsoLoginRequest,
  lhSsoLoginSuccess,
  lhSsoLoginFailure,
  resetLoyaltyHubSlice,
} = loyaltyHubSlice.actions;

export default loyaltyHubSlice.reducer;
